import StepAddImages from './StepAddImages.container';

export default StepAddImages;
